import React from 'react'
import WeFPO from './WeFPO'
import WhoWeWEFPO from './WhoWEFPO'
import Navbar from '../Header/Navbar'
import FPOTrust from './FPOTrust'
import Footer from '../Footer/Footer'
function FPOComponent() {
    return (
        <div>
            <Navbar/>
            <WeFPO/>
            <WhoWeWEFPO/>
            <FPOTrust/>
            <Footer/>
        </div>
    )
}

export default FPOComponent
